import React from 'react'

const style = {
    margin: '0.5rem 0 0.25rem 1rem',
    color: '#bf2525',
    fontSize: '0.95em',
    fontWeight: 'bold',
}

const ErrorInputWrap = ({children, error}) => {
    return (
        <div>
            {!!error 
                ? React.cloneElement(children, { style: {borderColor: '#bf2525'} }) : children
            } 
            {!!error && 
                <div style={style}>{error}</div>
            }
        </div>
    )
}

export default ErrorInputWrap


// WEBPACK FOOTER //
// ./src/components/utils/error-success/ErrorInputWrap.js